export default {
  INVESTMENTS(state, resp) {
    state.investments = resp;
  },

  PORTFOLIOS(state, resp) {
    state.portfolios = resp;
  },
};
